<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-No-Pagebreak">DRAMATIS PERSONAE</p>
<p class="ORIM-Chapter-Opener-Paragraph">Tom Haring: Producer, Moonthunder Records; Windhollow Faire’s Manager</p>
<p class="ORIM-Chapter-Opener-Paragraph">Windhollow Faire: </p>
<p class="ORIM-Body-Text">Lesley Stansall: Lead singer/songwriter</p>
<p class="ORIM-Body-Text">Ashton Moorehouse: Bassist</p>
<p class="ORIM-Body-Text">Jonathan Redheim: Drums, percussion</p>
<p class="ORIM-Body-Text">William Fogerty: Rhythm guitar, fiddle, mandolin</p>
<p class="ORIM-Body-Text">Julian Blake (deceased): Singer/songwriter, lead guitar</p>
<p class="ORIM-Chapter-Opener-Paragraph">Patricia Kenyon: Journalist/Music critic</p>
<p class="ORIM-Chapter-Opener-Paragraph">Nancy O’Neill: Professional psychic</p>
<p class="ORIM-Chapter-Opener-Paragraph">Billy Thomas: Photographer, estate agent</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled13.vue?78807a94